import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../../shared/Button"
import { userRoleDropdown } from "../../../../features/layout/layoutSlice"
import { setUserRole } from "../../../../features/auth/authSlice"
const Container = styled.div`
    height: auto;
    width: 180px;
    padding: 10px;
    position: absolute;
    background-color: ${({theme})=> theme.secondaryBgColor};
    left: -100px;
    top: 60px;
    z-index: 1;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    @media only screen and (max-width: 1550px) {
        top: 65px;
        right: 0;
        left: initial;
    }

    div{
        color: ${({ theme }) => theme.mainTextColor};
        font-weight: var(--font-weight-lg);
        font-size: 16px;
    }
    button{
        color: ${({ theme }) => theme.mainTextColor};
        border: 1px solid transparent;

        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 5px;
        width: 160px;
        font-weight: var(--font-weight-md);
        font-size: 14px;
        border-radius: 5px;

        &:hover{
            border-color: #989898;
        }
    }
`

const TopbarRoleDropdown = () => {

    const {userRole} = useSelector(state => state.auth)
    const dispatch = useDispatch()

    const handleClick = (type) => {
        dispatch(userRoleDropdown());
        dispatch(setUserRole(type))
    }
  return (
    <Container>
        <div>User Role: {userRole}</div>
        <button onClick={()=> handleClick("admin")}>admin</button>
        <button onClick={()=> handleClick("nakliyefirma")}>nakliyefirma</button>
        <button onClick={()=> handleClick("nakliyeyukveren")}>nakliyeyukveren</button>
        <button onClick={()=> handleClick("kooperatif")}>kooperatif</button>
        <button onClick={()=> handleClick("yukveren")}>yukveren</button>
    </Container>
  )
}

export default TopbarRoleDropdown